export default __webpack_public_path__ + "static/media/ivk_vwlt_prodomo.92b0ad61.svg";